import { FetchResult, FetchService } from './fetch-service';
import { UserData } from '../types/user/types';

/**
 * Service class for interacting with User Data on backend
 */
export class UserService {
  private fetchService: FetchService<UserData>;
  private static instance: UserService | null = null;

  private constructor() {
    this.fetchService = new FetchService();
  }

  public static getInstance(): UserService {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }

    return UserService.instance;
  }

  public async updateVisibility(userId: string, hidden: boolean): Promise<string> {
    const res: FetchResult<string> = await this.fetchService.update('user-data/visibility/update', {
      userId,
      hidden,
    } as unknown as UserData);
    if (res.success && res.data != null) {
      return res.data;
    }
    throw new Error(res.error ?? 'Unknown Error');
  }

  public async delete(data: UserData): Promise<string> {
    const res: FetchResult<string> = await this.fetchService.delete('user-data/delete', data);
    if (res.success) {
      if (res.data) {
        return res.data;
      }
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return '';
  }

  public async create(data: UserData): Promise<string> {
    const res: FetchResult<string> = await this.fetchService.create('user-data/add', data);
    if (res.success) {
      if (res.data) {
        return res.data;
      }
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return '';
  }

  public async get(data: UserData): Promise<UserData | null> {
    const res: FetchResult<UserData> = await this.fetchService.get('user-data/get', data);
    if (res.success) {
      const data: UserData | null = res.data;
      if (data != null) {
        return data;
      }
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return null;
  }

  public async getAll(): Promise<UserData[]> {
    const res: FetchResult<UserData[]> = await this.fetchService.getAll('user-data/get-all');
    if (res.success && res.data != null) {
      const allDatas: UserData[] = res.data;
      return allDatas;
    } else {
      if (res.error) {
        throw new Error(res.error);
      }
    }
    return [];
  }

}
